export default "__VITE_ASSET__D4pqNfN6__"